// removed by extract-text-webpack-plugin
module.exports = {"sk-folding-cube":"_3ZAb3_qiNCia2o-S1wIY3c","sk-cube":"cM_IClr0gGW5A2Imk2vxW","sk-foldCubeAngle":"_16bGu_rygZvtWh0Tu77F8W","sk-cube2":"rMPTh051RdQo66Hop6tBJ cM_IClr0gGW5A2Imk2vxW","sk-cube3":"_3JGd_SX97yM_QOw9kD-BhP cM_IClr0gGW5A2Imk2vxW","sk-cube4":"_3ilhocWnejoD6gplyLVdAU cM_IClr0gGW5A2Imk2vxW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/LoadingButton.scss
// module id = 43
// module chunks = 0 2 4 5 6 8 9 10 12 15 18 19 22 23 40